module.exports = __webpack_public_path__ + "media/images/catalog-promo/promo1176-febbeb3a1e043246f954522fb25ba257.jpg";